import React from "react";
import { EnrichedSwarovskiProductFrontendProductReview } from "@swo/storefront";
import { FONTS } from "../../styles/fonts";
import { PDPReviewStars } from "./PDP_SingleImageCarousel/PDPReviewStars";
import { PDPReviewCommentTopBarShell } from "./PDPReviewCommentTopBarShell";
import { css } from "@emotion/react";
import { CSS_MQ } from "../../styles/breakpoints";

export const PDPReviewCommentTopBar: React.FC<{
  author: EnrichedSwarovskiProductFrontendProductReview["author"];
  rating: EnrichedSwarovskiProductFrontendProductReview["rating"] | null;
  createdDateIsoString: EnrichedSwarovskiProductFrontendProductReview["createdDateIsoString"];
  reviewDateFormatter: (createdDateIsoString: string) => string;
}> = ({ author, rating, createdDateIsoString, reviewDateFormatter }) => {
  return (
    <PDPReviewCommentTopBarShell
      leftSide={
        <div
          css={css`
            display: flex;
            gap: 4px;

            ${CSS_MQ.atMostSm} {
              flex-direction: column;
              gap: 0;
            }
          `}
        >
          <span>{author.name}</span>
          <span title={createdDateIsoString} css={FONTS.SwarovskiFutura300}>
            {author.location} | {reviewDateFormatter(createdDateIsoString)}
          </span>
        </div>
      }
      rightSide={
        rating !== null ? (
          <span>
            <PDPReviewStars rating={rating} starsTheme="dark" />
          </span>
        ) : null
      }
    />
  );
};
